import { render } from "./PreviousEntries.vue?vue&type=template&id=d438db7e&scoped=true"
import script from "./PreviousEntries.vue?vue&type=script&lang=js"
export * from "./PreviousEntries.vue?vue&type=script&lang=js"

import "./PreviousEntries.vue?vue&type=style&index=0&id=d438db7e&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d438db7e"]])

export default __exports__